<template>
  <div class="comp-out-call-mky call-mky-popup" v-if="visible">
    <!-- <jw-modal :width="450" class="call-mky-popup" title-align="start" :mask="false" :mask-closable="false" draggable v-model:visible="visible" :footer="false" unmount-on-close :closable="false"> -->
    <!-- <template #title> -->
    <div class="mky-header" @mousedown="handleRemove">
      <span class="del" @click="close"><icon-close v-if="status !== 'Ring' && status !== 'Calling'" /></span>
      <jw-space>
        <label class="label">分机号码:</label>
        <span class="label-num">{{ detail.outNumber }} </span>
        <label class="label">当前状态:</label>
        <jw-tag size="mini" :color="classnameObj[status]?.color || '#86909c'">{{ classnameObj[status]?.label || '未注册' }}</jw-tag>
        <jw-button v-if="!classnameObj[status]" type="primary" size="small" @click="registerPhone">注册</jw-button>
      </jw-space>
    </div>
    <!-- </template> -->
    <div class="mky-content">
      <p>
        <span v-if="!classnameObj[status]?.label">请先注册分机状态后再拨打</span>
        <span v-else-if="status === 'Ring'">振铃中</span>
        <span v-else-if="status === 'Calling'">通话中</span>
        <span v-else-if="status === 'Failed'">呼叫失败，您可以继续尝试拨打</span>
        <span v-else>状态正常可拨打</span>
      </p>
      <div class="phone">{{ detail.callee || '暂无号码' }}</div>
      <div class="icon" :class="classnameObj[status]?.class || ''" :style="{ color: status === 'Failed' ? '#00b42a' : classnameObj[status]?.color || '#86909c' }">
        <jw-spin :loading="loading">
          <qf-icon-dial-phone class="" @click="phoneHandle" />
        </jw-spin>
      </div>
    </div>
    <!-- </jw-modal> -->
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { publicService } from '@/api/public-service';
import { Message } from '@arco-design/web-vue';
const visible = ref(false);
// const regStatus = ref(true);
const loading = ref(true);
const status = ref();
const detail = ref({});

const classnameObj = ref({
  Ring: { class: 'hangup', icon: '', color: '#f53f3f', label: '振铃中' },
  Calling: { class: 'hangup', icon: '', color: '#f53f3f', label: '通话中' },
  Idle: { class: 'call', icon: '', color: '#00b42a', label: '空闲' },
  Failed: { class: 'call', icon: '', color: '#f53f3f', label: '失败' }
});

const change = (value, CallInPhone = false) => {
  console.log(63, value);
  status.value = value;
  // status.text(classname[value].label);
  if (CallInPhone != false) {
    // $('#callin').text(CallInPhone);
  }
};
const Configs = {
  audioConfigs: {
    // ringout: "https://api.cn/statics/audio/ringout.wav", // 呼出振铃的音频地址
    // ringin: "https://api.cn/statics/audio/ringin.wav", // 呼入的振铃音频地址
    // hangup: "https://api.cn/statics/audio/dududu.wav",
  }, // 录音音频配置
  changeStatus: change, // 通话状态的变动回调
  log: true // sip信令debug排查
};
var rtc = null;
console.log(667, rtc);

// 注册分机
const registerPhone = () => {
  console.log(84, detail.value.outNumber);
  const cfg = {
    extension: detail.value.outNumber ? `${detail.value.outNumber}` : '',
    password: detail.value.password,
    sipserver: 'qdyss.mixcaller.com'
  };
  if (!detail.value.outNumber || !detail.value.password) {
    Message.error('用户名或密码未配置，请联系管理员');
    return;
  }
  console.log(84, cfg, rtc, detail.value.outNumber);
  rtc?.register(cfg);
  // regStatus.value = false;
};
// 获取基本信息
const open = async (params) => {
  console.log(86, params);
  visible.value = false;
  const doms = document.querySelectorAll('.call-mky-popup');
  console.log(105, doms);
  doms.length &&
    doms.forEach((el) => {
      el.style.display = 'none';
    });
  try {
    rtc = new WebRTC(Configs);
    loading.value = true;
    const json = await publicService.getMkyOutBound(params);
    console.log(21, json);
    if (!json.error) {
      const res = json.result;
      detail.value = res;
      console.log(21, res);
      if (!detail.value.outNumber || !detail.value.password) {
        Message.error('用户名或密码未配置，请联系管理员');
        visible.value = false;
        return;
      }
      visible.value = true;
      // regStatus.value = true;
      status.value = undefined;
      rtc?.WebSocket('wss://qdyss.mixcaller.com:8089/ws');
      // 自动注册分机号
      registerPhone();
      // 自动拨打电话
      setTimeout(() => {
        loading.value = false;
        outCall();
      }, 1000);
    } else {
      loading.value = false;
      console.log(113, loading.value, json.error);
      // Message.error(json.error?.msg || '获取数据失败');
    }
  } catch (e) {
    // loading.value = false;
    console.log(1131, e);
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};
// 拨打后给后端发信息
const saveData = async () => {
  try {
    const params = {
      businessId: detail.value?.id,
      // caller: detail.value?.caller,
      source: detail.value?.outNumber,
      callee: detail.value?.callee,
      type: detail.value?.type,
      orgId: detail.value?.orgId,
      userId: detail.value?.userId,
      status: status.value
    };
    await publicService.saveMkyOutBefore(params);
  } catch (e) {
    console.log(e);
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};
// 拨打
const phoneHandle = () => {
  if (status.value === 'Idle' || status.value === 'Failed') outCall();
  if (status.value === 'Ring' || status.value === 'Calling') {
    hangUp();
  }
};

// 外呼
const outCall = () => {
  rtc.call(detail.value.callee);
  saveData();
};
// 挂断
const hangUp = () => {
  rtc && rtc.hangup();
};

// 关闭弹窗
const close = () => {
  rtc && rtc?.unregister?.();
  visible.value = false;
};

// 导出
defineExpose({
  open
});

// 拖动
const handleRemove = (e) => {
  const tar = e.target;

  const getparent = (t, clas) => {
    if (t.nodeName === 'BODY') {
      return null;
    }
    if (['svg', 'path', 'g', 'circle'].lastIndexOf(t.nodeName) > -1) {
      return getparent(t?.parentNode, clas);
    }
    if (t?.className?.indexOf(clas) > -1) {
      return t;
    } else {
      return getparent(t?.parentNode, clas);
    }
  };
  const dom = getparent(tar, 'call-mky-popup');
  if (tar?.nodeName !== 'svg' && (tar?.className?.includes?.('mky-header') || tar?.parentNode?.className?.includes?.('mky-header') || tar?.parentNode?.parentNode?.className?.includes?.('mky-header') || tar?.parentNode?.parentNode?.parentNode?.className?.includes?.('mky-header'))) {
    const disX = e.clientX - dom.offsetLeft;
    const disY = e.clientY - dom.offsetTop;
    document.onmousemove = function (e) {
      let left = e.clientX - disX;
      let top = e.clientY - disY;
      if (left < dom.offsetWidth / 2) {
        left = dom.offsetWidth / 2;
      } else if (left > window.innerWidth - dom.offsetWidth / 2) {
        left = window.innerWidth - dom.offsetWidth / 2;
      }
      if (top < dom.offsetHeight / 2) {
        top = dom.offsetHeight / 2;
      } else if (top > window.innerWidth - dom.offsetHeight / 2) {
        top = window.innerWidth - dom.offsetHeight / 2;
      }

      dom.style.left = left + 'px';
      dom.style.top = top + 'px';
    };
    document.onmouseup = function () {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }
};

// onUnmounted(() => {
//   close();
// });
</script>
<style scoped lang="less">
@import './out-call-mky.less';
</style>
